import { GET_ONE } from "react-admin";
import dataProviderFactory from "../dataProvider";
import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import { isEmpty, sortBy, compose, prop } from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import styled from "styled-components";
import moment from "moment";
import NestedGrid from "./listBikeHistoryGrid";
const Card = styled.div(props => ({
  padding: "1em",
  backgroundColor: props.color,
  boxShadow: "rgb(245,157,29) 0px 1px 3px, rgb(250,228,195)  0px 1px 2px",
  marginTop: "0.5em"
}));

class ListBikeHistory extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    error: false,
    showDialog: false,
    data: [],
    dataSet: []
  };

  buildStructure = allItems => {
    const structure = [];
    const mainKeys = Object.keys(allItems);
    let tam = this.state.data.count;
    mainKeys.map(eventKey => {
      allItems[eventKey].map(event => {
        switch (eventKey) {
          case "rentals":
            structure.push({
              itemKey: tam,
              km: this.state.data.vehicle_mileage,
              description: `${event.type === 2 ? "Rental" : "Tour"} ${event.id
                }`,
              title: `${event.booking.r_first_name} ${event.booking.r_last_name}`,
              time1: event.time_1,
              time2: event.time_2,
              date1: event.date_1,
              date2: event.date_2,
              location1: event.location_1 ? event.location_1.location_name : "",
              cellLocation2Color: "",
              location2: event.location_2.location_name,
              bgColor: event.location_1
                ? event.location_1.color
                : event.location_2.color,
              bgColor2: event.location_2
                ? event.location_2.color
                : event.location_1.color,
              key: `${eventKey}_${event.id}`
            });
            break;
          case "holds":
            structure.push({
              itemKey: tam,
              km: this.state.data.vehicle_mileage,
              description: `Hold ${event.id}`,
              title: `Hold`,
              date1: event.start_date,
              date2: event.end_date,
              time1: "",
              time2: "",
              location1: "",
              cellLocation2Color: "",
              location2: "",
              bgColor: "whiteSmoke",
              key: `${eventKey}_${event.id}`
            });
            break;
          case "transfers":
            structure.push({
              itemKey: tam,
              km: this.state.data.vehicle_mileage,
              description: `Transfer ${event.id}`,
              title: `Transfer`,
              date1: event.transfer_date,
              date2: event.setup_date,
              time1: "",
              time2: "",
              location1: event.location_1 ? event.location_1.location_name : "",
              cellLocation2Color: event.location_2.color,
              location2: event.location_2.location_name,
              bgColor2: event.location_2
                ? event.location_2.color
                : event.location_1.color,
              bgColor: event.location_1
                ? event.location_1.color
                : event.location_2.color,
              key: `${eventKey}_${event.id}`
            });
            break;
          case "guide":
              structure.push({
                itemKey: tam,
                km: this.state.data.vehicle_mileage,
                description: `Guide bike ${event.id}`,
                title: `Guide bike`,
                date1: event.tour.tour_start_date,
                date2: event.tour.tour_end_date,
                time1: '10:00',
                time2: '18:00',
                location1: event.tour.location_1 ? event.tour.location_1.location_name : "",
                cellLocation2Color: 'event.location_2.color',
                location2: event.tour.location_2 ? event.tour.location_2.location_name : "",
                bgColor2: event.tour.location_2 ? event.tour.location_2.color : event.tour.location_1.color,
                bgColor: event.tour.location_1 ? event.tour.location_1.color : event.tour.location_2.color,
                key: `${eventKey}_${event.id}`
              });
              break;
          default:
            break;
        }
      });
    });
    return structure;
  };

  renderVehicle = vehicle => {
    const structure = this.buildStructure({
      rentals: vehicle.rentals,
      holds: vehicle.holds,
      transfers: vehicle.transfers,
      guide: vehicle.vehicleGuide
    });

    return (
      <React.Fragment>
        <Grid container spacing={8}>
          <Grid item xs={12} sm={12}>
            <b>Remaining activity:</b>
          </Grid>
        </Grid>
        <NestedGrid events={sortBy(compose(moment, prop("date2")), structure)}
        />
      </React.Fragment>
    );
  };

  async fetchData(id) {
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_ONE, "vehicles/for_date", { id });
    return response.data;
  }

  async componentDidMount() {
    //if (isEmpty(this.state.data)) {
    const data = await this.fetchData(this.props.vehicleId);
    this.setState({ data });
    //console.log(data);
    //Cargar fecha para realizar venta de moto
    const dataO = data.rentals; //fechas de rentas pendientes

    dataO.sort(function (a, b) {
      return new Date(b.date_2) - new Date(a.date_2);
    });
    let valor = dataO[0];  //primer renta ordenada descententemente
    let fecha2 = moment().add(1, 'days');
    if (valor != null) {
      fecha2 = valor.date_2;
      fecha2 = moment(fecha2).add(1, 'days');
    }
    else{
      const dataG = data.vehicleGuide;
      const dataH = data.holds;
      const dataT = data.transfers;
      const arrayFecha = []
    
      dataG.forEach(a => {
        arrayFecha.push(a.tour.tour_end_date)
      });
      dataH.forEach(a => {
        arrayFecha.push(a.end_date)
      });
      dataT.forEach(a => {
        arrayFecha.push(a.end_date)
      });
      arrayFecha.sort(function (a, b) { 
        return new Date(b) - new Date(a);
      });
      let valor = arrayFecha[0];  //primer renta ordenada
      fecha2 = valor;
      fecha2 = moment(fecha2).add(1, 'days');

    }
    try {
      this.props.SetDate(fecha2);
    } catch (error) {

    }

    //inicializa la fecha ultima de entrega de moto post renta
    //}
  }

  render() {
    if (isEmpty(this.state.data)) {
      return <LinearProgress />;
    }

    return <Card>{this.renderVehicle(this.state.data)}</Card>;
  }
}

export default ListBikeHistory;



// WEBPACK FOOTER //
// ./src/components/listBikeHistory.js